<template>
  <div id="transactions">
    <div class="padding-top-5"></div>
    <div class="margin-10 box-shadow">
      <div class="bg-light padding-10 align-ver center-hor">
        <div class="align-hor center-ver space-around padding-10 margin-bottom-10 text-uppercase">
          <div class="radio custom-radio no-margin pull-left" @click="toggleBankUPI(false)">
            <label class="pointer">
              <input type="radio" name="redeem_type" id="bank" value="bank" required checked>
              Bank
            </label>
          </div>
          <div class="radio custom-radio no-margin pull-right" @click="toggleBankUPI(true)">
            <label class="pointer">
              <input type="radio" name="redeem_type" id="upi" value="upi" required>
              UPI
            </label>
          </div>
        </div>
        <div>
          <div class="bank-details" v-if="!is_upi">
            <input class="margin-bottom-10 custom-input w80" type="text" v-model="acNumber" placeholder="A/C Number">
            <input class="margin-bottom-10 custom-input w80" type="text" v-model="ifsc" placeholder="IFSC">
            <input class="margin-bottom-10 custom-input w80" type="text" v-model="acHolderName" placeholder="Account Holder's Name">
          </div>
          <div class="upi-details" v-else>
            <input class="margin-bottom-10 custom-input w80" type="text" v-model="upiId" placeholder="Enter UPI ID">
          </div>
          <div class="margin-bottom-10 text-regular" v-if="reward_bal">{{reward_bal}} will be transferred into above mentioned {{type}} details</div>
          <button class="custom-button small text-light padding-0510 radius-5 text-uppercase pointer" :style="{background: bgTheme}" @click="redeemRequest($event)">withdraw</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  export default {
    mixins: [globals],
    data() {
      return {
        type: 'bank',
        is_upi: false,
        acNumber: '',
        ifsc: '',
        acHolderName: '',
        upiId: '',
        reward_bal: ''
      }
    },
    methods: {
      toggleBankUPI(state) {
        if(state == false) {
          this.type = 'bank';
        } else {
          this.type = 'upi';
        }
        this.is_upi = state;
      },
      redeemRequest(event) {
        var ac_type = this.type;
        var number = this.acNumber;
        var ifsc = this.ifsc;
        var name = this.acHolderName;
        var upi_id = this.upiId;
        var data = {ac_type: ac_type};
        if(ac_type == 'bank') {
          if(!number) {
            this.toastPopup(true, "Please enter the valid Account number");
            return false;
          }
          if(!ifsc) {
            this.toastPopup(true, "Please enter the valid IFSC code");
            return false;
          }
          if(!name) {
            this.toastPopup(true, "Please enter the valid Account holder name");
            return false;
          }

          data.number = number;
          data.ifsc = ifsc;
          data.name = name;
        } else if(ac_type == 'upi') {
          if(!upi_id) {
            this.toastPopup(true, "Please enter the valid UPI ID");
            return false;
          }
          data.upi_id = upi_id;
        }

        var url = this.$store.getters.flyyDomain+'/transfer_requests';
        var headers = this.$store.getters.headers;

        var options = {
          method: 'post',
          url: url,
          headers: headers,
          data: data,
        }
        event.target.disabled = true;
        axios(options).then((resp) => {
          if(resp.status == 200) {
            if(resp.data.success) {
              this.toastPopup(true, resp.data.message);
              this.back();
            } else {
              event.target.disabled = false;
              this.toastPopup(true, resp.data.message);
            }
          } else {
            event.target.disabled = false;
            this.toastPopup(true, resp.data.message);
          }
        }).catch((err) => {
          event.target.disabled = false;
          console.log("Redemption error!");
        });
      }
    },
    created() {
      if(!this.isEmpty(this.$route.query)) {
        this.reward_bal = this.$route.query.bal ? this.$route.query.bal : '';
      }
      this.$store.state.showHeader = true;
      this.$store.state.showWallet = false;
      this.$store.state.showHistory = false;
      this.$store.state.user.headerBalance.show = false;
      this.$store.state.headTitle = "Redeem";
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/redeem.vue